import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconInfoCircle } from '#src/atoms/icons/system/iconInfoCircle.ts';
import { Bold } from '#src/atoms/typography/Bold/index.tsx';
import { BodyM } from '#src/atoms/typography/index.tsx';
import { laptopAndAbove } from '#src/style/mediaQuery.ts';

const Root = styled(ButtonBase)`
  display: flex;
  gap: var(--unit);
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  border-radius: 16px;
  padding: var(--double-unit);
  background: var(--c-surface-caution);
  text-align: left;
  width: 100%;
  b {
    color: var(--c-yellow-400);
  }
  @media ${laptopAndAbove} {
    flex-wrap: nowrap;
  }
`;
const Info = styled.div`
  display: flex;
  gap: var(--unit);
`;
const ButtonWrapper = styled(Button)`
  width: 100%;
  @media ${laptopAndAbove} {
    flex-shrink: 0;
    width: auto;
  }
`;

type Props = {
  onClick?: () => Promise<void>;
  loading?: boolean;
};

export const Warning = ({ onClick, loading }: Props) => {
  return (
    <Root as={onClick ? 'button' : 'div'} type="button" onClick={onClick}>
      <Info>
        <BodyM color="var(--c-yellow-400)">
          <FontAwesomeIcon icon={iconInfoCircle} />
        </BodyM>
        <BodyM>
          <FormattedMessage
            defaultMessage="If a card is <b>listed in the market</b> the points do not count in the collection score"
            values={{ b: Bold }}
          />
        </BodyM>
      </Info>
      {!!onClick && (
        <ButtonWrapper
          asSpan
          color="secondary"
          size="small"
          loading={!!loading}
        >
          <FormattedMessage defaultMessage="Unlist" />
        </ButtonWrapper>
      )}
    </Root>
  );
};
